import axios from 'axios'
import {store} from "../storage"
import {eventHub} from '../../eventhub'

const url = 'http://10.1.110.121:8000/publicaciones'
axios.defaults.headers.common['Authorization'] = 'JWT ' + localStorage.getItem('t');

axios.interceptors.request.use(
  conf => {
    state.peticionesSuccess++
    if (state.peticionesSuccess == 3)
      eventHub.$emit('before-request');
    return conf;
  },
  error => {
    eventHub.$emit('request-error');
    return Promise.reject(error);
  }
)
axios.interceptors.response.use(
  response => {
    eventHub.$emit('after-response');
    return response;
  },
  error => {
    eventHub.$emit('response-error');
    return Promise.reject(error);
  }
)

const state = {
  endpoints: {
    autores: url + '/autors/',
    articulos: url + '/articulos/',
    libros: url + '/libros/',
    eventos: url + '/eventos/',
    autorproduccion: url + '/autorproduccion/',
    revistas: url + '/revistas/',
    produccion_cientifica: url + '/produccion_cientifica/',
    totales: url + "/totales/"
  },
  autores: [],
  articulos: [],
  libros: [],
  eventos: [],
  revistas: [],
  autorproduccion: [],
  produccion_cientifica: [],
  totales: [],
  peticionesSuccess: 0
}


const mutations = {
  /**AUTORES**/
  async listarAutores(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.autores).then((response) => {
      state.autores = response.data
    }).catch(error => {
      state.autores = []
    })
  },
  /**ARTICULOS**/
  async listarArticulos(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.articulos).then((response) => {
      state.articulos = response.data
      localStorage.setItem('articulos', JSON.stringify(state.articulos));
    }).catch(error => {
      state.articulos = []
    })
  },
  /**LIBROS**/
  async listarLibros(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.libros).then((response) => {
      state.libros = response.data
    }).catch(error => {
      state.libros = []
    })
  },
  /**EVENTOS**/
  async listarEventos(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.eventos).then((response) => {
      state.eventos = response.data
    }).catch(error => {
      state.eventos = []
    })
  },
  /**AUTORES--PRODUCCION**/
  async listaAutoresProduccion(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.autorproduccion).then((response) => {
      state.autorproduccion = response.data
    }).catch(error => {
      state.autorproduccion = []
    })
  },
  /**REVISTAS**/
  async listaRevistas(state) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.revistas).then((response) => {
      state.revistas = response.data
      localStorage.setItem('revistas', JSON.stringify(state.revistas));
    }).catch(error => {
      state.revistas = []
    })
  },
  /**Produccion Cientifica**/
  async produccionCientifica(state, payload) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.produccion_cientifica, {
      params: {
        first_year: payload.first_year,
        last_year: payload.last_year
      }
    }).then((response) => {
      state.produccion_cientifica = response.data
    }).catch(error => {
      state.produccion_cientifica = []
    })
  },

  /**Totales**/
  async totales(state, payload) {
    axios.defaults.headers.common['Authorization'] = '';
    await axios.get(state.endpoints.totales)
      .then((response) => {
        state.totales = response.data
        sessionStorage.setItem('totales', JSON.stringify(response.data));
      }).catch(error => {
        state.totales = []
      })
  },
}


const actions = {
  /**AUTORES**/
  getAutores({commit}, jwt) {
    commit('listarAutores')
  },
  /**ARTICULOS**/
  getArticulos({commit}) {
    commit('listarArticulos')
  },
  /**LIBROS**/
  getLibros({commit}, jwt) {
    commit('listarLibros')
  },
  /**EVENTOS**/
  getEventos({commit}, jwt) {
    commit('listarEventos')
  },
  /**REVISTAS**/
  getRevistas({commit}, jwt) {
    commit('listaRevistas')
  },
  /**AUTORES--PRODUCCION**/
  getAutoresProduccion({commit}, jwt) {
    commit('listaAutoresProduccion')
  },
  /**PRODUCCION Cientifica**/
  getproduccionCientifica({commit}, first_year, last_year) {
    commit('produccionCientifica', first_year, last_year)
  },
  /**Totales**/
  getTotales({commit}) {
    commit('totales')
  },
}

const getters = {
  autores: (state) => {
    return state.autores
  },
  articulos: (state) => {
    return state.articulos
  },
  libros: (state) => {
    return state.libros
  },
  eventos: (state) => {
    return state.eventos
  },
  revistas: (state) => {
    return state.revistas
  },
  autorproduccion: (state) => {
    return state.autorproduccion
  },
  countautorproduccion: (state) => {
    return state.autorproduccion.length
  },
  totals: (state) => {
    return state.totales
  },
  articulosPorciento: (state) => Math.round(parseFloat((state.articulos.length * 100) / (state.articulos.length + state.eventos.length + state.libros.length))),
  eventosPorciento: (state) => ((state.eventos.length * 100) / (state.articulos.length + state.eventos.length + state.libros.length)),
  librosPorciento: (state) => ((state.libros.length * 100) / (state.articulos.length + state.eventos.length + state.libros.length)),

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/storage/modules/publicaciones.js